module.exports = __webpack_public_path__ + "static/media/icon-quote.a55a102a.svg";